/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".applied-vouchers[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:8px}.voucher-tag[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;background-color:#d4edda;color:#155724;border:1px solid #c3e6cb;padding:8px 12px;border-radius:6px;font-size:14px}.voucher-info[_ngcontent-%COMP%]{flex:1}.remove-btn[_ngcontent-%COMP%]{background:0 0;border:none;color:#c0392b;font-size:16px;font-weight:700;cursor:pointer;line-height:1;padding:2px 6px}.remove-btn[_ngcontent-%COMP%]:hover{color:#e74c3c}"];
export { styles as styles };
